import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

export class ArticleSlider {
  constructor() {
    this.slidersEl = [...document.getElementsByClassName('js-opencampus-article-slider')]
    console.log(this.slidersEl)

    if (this.slidersEl.length === 0) return
    this.sliders = this.slidersEl.map((sliderEl) => {
      sliderEl.classList.add('keen-slider')
      const slides = [...sliderEl.children]
      slides.forEach((slide) => {
        slide.classList.add('keen-slider__slide')
      })
      const controls = document.createElement('div')
      controls.className = 'c-post_opencampus__about__controls'
      const prev = document.createElement('button')
      const next = document.createElement('button')
      next.className = '-next'

      prev.type = next.type = 'button'
      prev.innerHTML =
        next.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path fill=currentColor d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`
      const dotList = document.createElement('ul')
      slides.forEach((_, idx) => {
        const dot = document.createElement('li')
        dot.className = idx === 0 ? 'dot is-act' : 'dot'
        dot.addEventListener('click', () => {
          slides.moveToSlide(idx)
        })
        dotList.appendChild(dot)
      })
      controls.appendChild(prev)
      controls.appendChild(dotList)
      controls.appendChild(next)

      return new KeenSlider(sliderEl, {
        slides: {
          perView: 1,
        },
        created: (s) => {
          s.container.parentNode.appendChild(controls)
          prev.disabled = s.track.details.rel === 0
          prev.addEventListener('click', () => s.prev())
          next.addEventListener('click', () => s.next())
        },
        slideChanged: (s) => {
          const current = s.track.details.rel
          Array.from(dotList.children).forEach((dot, idx) => {
            idx === current ? dot.classList.add('is-act') : dot.classList.remove('is-act')
          })
          prev.disabled = current === 0
          next.disabled = current === s.track.details.maxIdx
        },
      })
    })
  }
}
